import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=85e50f4c"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=85e50f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports